import { NextVisit } from "../components/types";

export type DocumentSuccessResponse = {
  documentHTML: string;
  jsonData: any;
  id: number;
  title: string;
};

export type DocumentResponse = DocumentSuccessResponse |
  LastDocumentSuccessResponse;

export const checkIsLastDocumentSuccessResponse = (
  response: DocumentResponse
): response is LastDocumentSuccessResponse => {
  return "isLastDocument" in response && response.isLastDocument === true;
};

export const checkIsDocumentSuccessResponse = (
  response: DocumentResponse
): response is DocumentSuccessResponse => {
  return "documentHTML" in response;
};export type LastDocumentSuccessResponse = {
  isLastDocument: true;
  successMessage: string;
  nextVisit?: NextVisit;
};

